import React, { useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Lookup } from './Lookup/lookup';
import { Category, ICategoryValue } from './Category/category';
import { ILookupData } from '../games';
import { WindowsIcon } from '../../../utils/icons/windows';
import { AppleIcon } from '../../../utils/icons/apple';
import { t } from 'i18next';

export const FiltersPane = ({
	setLookupData,
}: {
	setLookupData: React.Dispatch<React.SetStateAction<ILookupData>>;
}) => {
	const [keywords, setKeywords] = useState('');
	const [genre, setGenre] = useState<string[]>([]);
	const [platform, setPlatform] = useState<string[]>([]);
	const [cartridge, setCartridge] = useState<string[]>([]);

	const [keywordsDelayed, handleKeywordsDelayed] = useState('');
	const [timeout, handleTimeout] = useState<any>(null);

	const filters: { [p: string]: ICategoryValue[] } = {
		platform: [
			{ name: t('library.filter.option.windows').toString(), value: 'pc', icon: <WindowsIcon /> },
			{ name: t('library.filter.option.macos').toString(), value: 'macos', icon: <AppleIcon /> },
			{ name: t('library.filter.option.html').toString(), value: 'html' },
		],
		genre: [
			{ name: t('library.filter.option.rpg').toString(), value: 'rpg' },
			{ name: t('library.filter.option.adventure').toString(), value: 'adventure' },
			{ name: t('library.filter.option.strategy').toString(), value: 'strategy' },
		],
		cartridge: [
			{ name: t('library.filter.option.gold').toString(), value: 'gold' },
			{ name: t('library.filter.option.gray_').toString(), value: 'gray' },
			{ name: t('library.filter.option.custom').toString(), value: 'custom' },
		],
	};

	useEffect(() => {
		if (timeout) {
			clearTimeout(timeout);
		}

		handleTimeout(
			setTimeout(() => {
				clearTimeout(timeout);
				handleKeywordsDelayed(keywords);
			}, 150)
		);
	}, [keywords]);

	useEffect(
		() => setLookupData({ keywords: keywordsDelayed, genre, platform, cartridge }),
		[keywordsDelayed, genre, platform, cartridge]
	);

	return (
		<Flex
			flexDirection="column"
			flexGrow="1"
			gridGap="32px"
			fontSize="12px"
			margin={{ base: 'auto', hashup: 'unset' }}
		>
			<Flex
				flexDirection="column"
				gridGap="16px"
			>
				<Text
					fontSize="14px"
					lineHeight="17px"
				>
					{t('library.filter.title').toString()}
				</Text>
				<Lookup
					value={keywords}
					handleChange={setKeywords}
				/>
			</Flex>
			<Category
				header={t('library.filter.type.platform').toString()}
				data={filters.platform}
				handleDataChange={setPlatform}
			/>
			<Category
				header={t('library.filter.type.genre').toString()}
				data={filters.genre}
				handleDataChange={setGenre}
			/>
			<Category
				header={t('library.filter.type.cartridge').toString()}
				data={filters.cartridge}
				handleDataChange={setCartridge}
			/>
		</Flex>
	);
};
